// Utilitaire de formatage monétaire pour le Mandat (Lot M3).
export const fmtMoney = (value, currency = "EUR") => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  try {
    return new Intl.NumberFormat("fr-FR", {
      style: "currency", currency,
      maximumFractionDigits: 0,
    }).format(Number(value));
  } catch {
    return `${value} ${currency}`;
  }
};

export const deltaPct = (from, to) => {
  const f = Number(from), t = Number(to);
  if (!f || !t) return null;
  return ((t - f) / f) * 100;
};
